export enum TypeDeProduitEnum {
    article = 0,
    pack = 1
}
